var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      { staticClass: "autocomplete", class: { "full-width": _vm.fullWidth } },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search"
            }
          ],
          ref: "search",
          attrs: {
            autofocus: "autofocus",
            type: "text",
            autocomplete: "off",
            minlength: "3",
            maxlength: "64",
            required: "required",
            pattern: ".{1,}",
            title: "Podaj nazwę lub kod produktu",
            placeholder: "Czego szukasz?"
          },
          domProps: { value: _vm.search },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.search = $event.target.value
              },
              _vm.onSearchChange
            ],
            keyup: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                return _vm.onSearchArrowUp($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                return _vm.onSearchArrowDown($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onSearchEnter($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                return _vm.$emit("hide-search")
              }
            ]
          }
        }),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAutocompleteOpen,
                expression: "isAutocompleteOpen"
              }
            ],
            staticClass: "autocomplete-results",
            attrs: { id: "autocomplete-results" }
          },
          [
            _vm.isAutocompleteLoading
              ? _c("li", { staticClass: "autocomplete-result" }, [_vm._m(0)])
              : _vm._l(_vm.results, function(result, i) {
                  return _c(
                    "li",
                    {
                      key: i,
                      staticClass: "autocomplete-result",
                      class: { "is-active": i === _vm.arrowCounter },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.setResult(result)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(result.value) +
                          "\n            "
                      )
                    ]
                  )
                })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "mobile-magnifier-button",
        attrs: { type: "submit" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("search", _vm.search)
          }
        }
      },
      [
        _c("img", {
          attrs: {
            src: "images/magnifier.svg",
            width: "16",
            height: "16",
            alt: "Szukaj"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ring" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }